<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    color="transparent"
    flat
    height="75"
  >
    <v-btn
      class="mr-3"
      elevation="1"
      fab
      small
      @click="setDrawer(!drawer)"
    >
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>

    <v-toolbar-title
      class="hidden-sm-and-down font-weight-light"
      v-text="$route.name"
    />

    <v-spacer />

    <v-btn
      v-show="role != 'ROLE_USER'"
      class="ml-2"
      min-width="0"
      text
      :to="dirTo + 'dashboard'"
    >
      <v-icon>mdi-view-dashboard</v-icon>
    </v-btn>

    <v-menu
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-badge
            v-if="count != 0 && count != ''"
            color="red"
            overlap
            bordered
          >
            <template v-slot:badge>
              <span>{{ count }}</span>
            </template>

            <v-icon>mdi-bell</v-icon>
          </v-badge>
          <v-icon v-else>
            mdi-bell
          </v-icon>
        </v-btn>
      </template>

      <v-list
        :tile="false"
        nav
      >
        <div>
          <app-bar-item
            v-for="(n, i) in notifications"
            :key="`item-${i}`"
          >
            <v-list-item-content @click="vista(n.id)">
              <v-list-item-title v-text="n.mensaje" />
            </v-list-item-content>
          </app-bar-item>
          <app-bar-item
            v-if="count == 0 && count == ''"
          >
            <v-list-item-content @click="notificacionesAll()">
              <v-list-item-title>Ver todas</v-list-item-title>
            </v-list-item-content>
          </app-bar-item>
        </div>
      </v-list>
    </v-menu>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          :to="dirTo + 'perfil'"
          v-on="on"
        >
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>
      <span>{{ infoUser }}</span>
    </v-tooltip>

    <v-btn
      class="ml-2"
      min-width="0"
      text
      to="/logout"
    >
      <v-icon>mdi-logout</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
  import { VHover, VListItem } from 'vuetify/lib'
  // Utilities
  import { mapState, mapMutations } from 'vuex'

  import NotificacionesApi from '@/services/api/Notificaciones'
  import router from '../../../../router'
  import EventBus from '../../../../bus'
  import Vue from 'vue'

  export default Vue.extend({
    name: 'DashboardCoreAppBar',

    components: {
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      notifications: [],
      count: '',
      role: '',
    }),

    computed: {
      ...mapState(['drawer']),
      dirTo () {
        let base = null
        switch (localStorage.getItem('role')) {
          case 'ROLE_ADMIN':
            base = '/admin/'
            break
          case 'ROLE_CLIENTE':
            base = '/cliente/'
            break
          case 'ROLE_OFICIAL':
            base = '/oficial/'
            break
          case 'ROLE_USER':
            base = '/user/'
            break
          case 'ROLE_NOTARIO':
            base = '/notario/'
            break
        }
        return base
      },
      infoUser () {
        let info = localStorage.getItem('user')

        switch (localStorage.getItem('role')) {
          case 'ROLE_ADMIN':
            info += ' - Administrador'
            break
          case 'ROLE_CLIENTE':
            info += ' - Cliente'
            break
          case 'ROLE_OFICIAL':
            info += ' - Oficial'
            break
          case 'ROLE_USER':
            info += ' - Usuario'
            break
          case 'ROLE_NOTARIO':
            info += ' - Notario'
            break
        }
        return info
      },
    },

    created () {
      this.initialize()
      this.role = localStorage.getItem('role')
    },

    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),
      fetchNotificacion () {
        this.$store.dispatch('getNotificacionesPendientes')
          .then(notificacion => {
            this.notifications = notificacion
            this.count = notificacion.length
          })
          .catch(error => console.log(error))
      },
      initialize () {
        this.fetchNotificacion()
        EventBus.$on('update-fetch_notify', () => {
          this.fetchNotificacion()
        })
      },
      vista (id) {
        NotificacionesApi.updateNotificacion(id)
          .then(notificacion => {
            EventBus.$emit('update-table-notify')
            this.notificacionesAll()
          })
          .catch(error => console.log(error))
      },
      notificacionesAll () {
        this.fetchNotificacion()
        router.push({ path: '/notificaciones' })
      },
    },
  })
</script>
